import { useState } from 'react';
import { Flex, Subtitle } from './TremorCompat';
import { Button, Icon } from './TremorCompat';
import { checkUserNameValid, checkIdValid } from '../utils/utilities';
import Modal from 'rsuite/Modal';
import Input from 'rsuite/Input';
import { MdOutlineEdit as IconEdit } from 'react-icons/md';
import { COLOURS } from '../styles';
import { controller_t } from '../constants';
import { encode_mac_address, getModelTypeValueFromUID } from '../utils/uid';
import { getModelTypeStringFromValue } from '../utils/deviceState';
import { getControllerIconText_FROM_STRING } from './DisplayItems';

const showModelDeviceWithCheckBox = (modelType, model_type, validateType) => {
  return (
    <Flex justifyContent="start" alignItems="center" className="space-x-1">
      <img
        src={getControllerIconText_FROM_STRING(getModelTypeStringFromValue(modelType)).icon}
        alt="Controller Icon"
        width="40"
        height="40"
      />
      <input
        type="radio"
        name="controllers"
        value={getModelTypeStringFromValue(modelType)}
        checked={model_type === getModelTypeStringFromValue(modelType)}
        onChange={validateType}
      />
      <span style={{ fontSize: '0.85em' }}>{getModelTypeStringFromValue(modelType)}</span>
    </Flex>
  );
};

export const AddDeviceInfo = ({ open, handleClose }) => {
  const [name, setName] = useState('Device Name');
  const [id, setId] = useState('');
  const [idValid, setIdValid] = useState(false);
  const [valid, setValid] = useState(true);
  const [model_type, setType] = useState('');
  const validateId = (value) => {
    if (value.length === 17) //UID
    {
      //Need to determine the type from the UID
      setType(getModelTypeValueFromUID(value).string);
    } else if (value.length === 12) // MAC address
    {
      //Convert value to MAC address.
      value = encode_mac_address(value, controller_t.AQUATEK);
    }

    setId(value);
    setIdValid(checkIdValid(value));
  };

  const validate = (value) => {
    setName(value);
    setValid(checkUserNameValid(value));
  };

  const validateUserName = (value) => {
    setName(value);
    setValid(checkUserNameValid(value));
  };

  const validateType = (e) => {
    setType(e.currentTarget.value);
  };

  return (
    <Modal open={open} onClose={() => handleClose(null)} backdrop="static">
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <Flex justifyContent="start" alignItems="center" className="space-x-1">
            <Icon icon={IconEdit} color={COLOURS.default} />
            <Subtitle color={COLOURS.default}>Edit controller</Subtitle>
          </Flex>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-3">
          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>ID</span>
            <Input placeholder="Enter a valid ID" maxLength={17} size="sm" value={id} onChange={validateId} />
          </label>
          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>Name</span>
            <Input value={name} placeholder="Enter a valid name" maxLength={200} size="sm" onChange={validate} />
          </label>

          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>User Name</span>
            <Input
              value={name}
              placeholder="Enter a valid name"
              maxLength={200}
              size="sm"
              onChange={validateUserName}
            />
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Flex justifyContent="end" alignItems="center" className="space-x-2">
          {/* <Button color={COLOURS.default} size="sm" onClick={() => handleClose({  })} disabled={!idValid || !valid }>Confirm</Button> */}
          <Button
            color={COLOURS.default}
            size="sm"
            onClick={() => handleClose({ id, name, modeltype: model_type })}
            disabled={!idValid || !valid}
          >
            Confirm
          </Button>
          <Button color={COLOURS.default} size="sm" variant="secondary" onClick={() => handleClose(null)}>
            Cancel
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
